module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-titlec",
    attrs: {
      "id": "lev_10"
    }
  }, [_vm._v("Chronology of the Bourbon Era")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1700")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("1 Nov")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Death of Carlos II, the last Habsburg King of Spain, without heirs.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("16 Nov")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Proclamation (in Versailles) of Philippe d’Anjou as Felipe V of Spain.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1701")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("15 May")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Declaration of War by the Grand Alliance began War of the Spanish Succession.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1702")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("23 Oct")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Battle of Vigo.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1704")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("23 July")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("English capture of Gibraltar.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1713")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("9 Dec")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Treaty of Utrecht ended war between Spain and Britain.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1718")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("11 Aug")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Battle of Cape Passaro (off south-east coast of Sicily).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1724")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("15 Jan")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Abdication of Felipe V, and accession of his son Luis.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("6 Sept")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Death of Luis, and restoration of Felipe V.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1740")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("8 Apr")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Action off Cape Finisterre.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1744")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("22 Feb")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Battle of Cape Sicié (also called Battle of Toulon).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1746")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("9 July")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Death of Felipe V, and accession of his fourth son, Fernando VI.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1748")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("12 Oct")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Action off Havana.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1759")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("10 Aug")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Death of Fernando VI, and accession of his half-brother, Carlos III (fifth son of Felipe V).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1762")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Mar")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Siege of Havana (to May).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("24 Sept")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Battle of Manila (to 6 Oct).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1780")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("16 Jan")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("2nd Battle of Cape St Vincent (Rodney’s ‘Moonlight battle’), also called the Battle of Cape Santa María in Spanish.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1780")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("20 Oct")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Battle of Cape Spartel.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1788")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("14 Dec.")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Death of Carlos III, and accession of his son, Carlos IV.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1793")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("27 Aug")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Anglo-Spanish Occupation of Toulon.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1797")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("14 Feb")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("3rd Battle of Cape St Vincent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("17 Feb")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Action in Chaguaramas Bay (Trinidad)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1801")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("12 July")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Action off Gibraltar (Battle of Algeciras Bay)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1805")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("22 July")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Battle of Cape Finisterre (‘Calder’s Action’).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("22 Oct")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Battle of Cape Trafalgar.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1808")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("19 Mar")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("First abdication of Carlos IV, and accession of his son Fernando VII.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("2 May")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Uprising of Madrid against the French occupation starts war against France (to Apr 1814).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("5 May")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("‘Abdication’ (enforced) of Fernando VII, and temporary restoration of Carlos IV.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("6 May")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Second abdication of Carlos IV, with throne ceded to Napoleon.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("6 June")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Appointment (by Napoleon) of his brother Joseph Bonaparte as (King) José.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1813")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("11 Dec")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Deposition of José, and restoration of Fernando VII.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1833")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("29 Sept")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Death of Fernando VII, and accession of his daughter, Isabel II.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1833")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Start of 1st Carlist War between absolutists and liberals (to 1840).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1846")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("2nd Carlist War (to 1849).")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1865")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Start of Spanish-South American War (or ‘Chincha Islands War’) between Spain and her former colonies of Chile, Peru, Ecuador and Bolivia.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("26 Nov")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Battle of Papupo (between Spain’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Covadonga")]), _vm._v(" and Chile’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esmeralda")]), _vm._v(")")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1866")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("2 Feb")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Battle of Abtao between 2 Spanish frigates and an Allied (Chilean-Peruvian) squadron.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("31 Mar")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Bombardment of Valparaiso by Spanish squadron destroyed 33 Chilean merchant ships.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("2 May")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Attack on Callao (Chile) by Spanish squadron.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1868")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("30 Sept")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Deposition of Isabel II, and Regency of General Francisco Serrano y Domínguez.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1870")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("16 Nov")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("‘Election’ of Amadeo (of House of Savoy-Carignano) as King.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1872")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("3rd Carlist War (to 1876)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1873")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("11 Feb")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Abdication of Amadeo, and establishment of First Republic of Spain.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1874,")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("29 Dec")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Restoration of House of Bourbon under Alfonso XII, son of Isabel II.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0882f88b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chronology1.vue
// module id = 87
// module chunks = 0